export default __webpack_public_path__ + "static/media/GPA22064_WebsiteBanners_Secondary.aa75c356.png";